import {
  dragDropPieces,
  lesson10Assignment1,
  lesson10Assignment2,
  lesson10Assignment3
} from './assignments'
import { createChessboard } from '../../utils'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_10/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    audio: { src: 'img/audio/lesson_10/1.mp3', start: true, controls: false },
    directions: {
      timeout: 5000,
      data: `<b>DIRECTIONS:</b> <br/>Match the chess <br/>piece with the <br/>correct feature <br>or talent.`
    },
    activity: {
      assignmentClass: 'assignment-10-1',
      callback: lesson10Assignment1({
        next: 3
      }),
    },
    chessboard: {
      board: dragDropPieces({
        singleSpare: true,
        assignmentClass: 'assignment-10-1',
        piecesArray: ['bK', 'bQ', 'bR', 'bB', 'bN', 'bP'],
        validatePieces: { 'bK': ['a4'], 'bQ': ['a6'], 'bR': ['a2'], 'bB': ['a7'], 'bN': ['a5'], 'bP': ['a3'] },
        pieceLimit: { bK: 1, bQ: 1, bR: 1, bB: 1, bN: 1, bP: 1 },
        resultFen: '8/b7/q7/n7/k7/p7/r7/8',
        pieceTheme: 'assignment_10_1',
        next: 3
      })
    }
  },
  {
    id: 2,
    previous: 0,
    next: 6,
    video: {
      src: 'img/videos/lesson_10/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 4,
    }
  },
  {
    id: 3,
    previous: 0,
    next: 6,
    video: {
      src: 'img/videos/lesson_10/2.1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 4,
    }
  },
  {
    id: 4,
    previous: 2,
    next: 5,
    audio: { src: 'img/audio/lesson_10/2.mp3', start: true, controls: false },
    directions: {
      timeout: 5000,
      data: `<b>DIRECTIONS:</b> <br/>Move the King <br/>and Rook to castle <br/>on the white <br/>King’s side.`
    },
    chessboard: {
      board: lesson10Assignment2({
        showIndicators: { allSides: true },
        position: 'r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R',
        finalPosition: 'r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1',
        startChance: ' w KQkq - 0 1',
        assignmentClass: 'custom-sparepiece',
        kingTarget: 'g1',
        rookTarget: 'f1',
        source: 'e1',
        target: 'g1',
        next: 5
      }),
      positionFen: 'r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R w KQkq - 0 1'
    }
  },
  {
    id: 5,
    previous: 4,
    next: 6,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Move the King <br/>and Rook to castle <br/>on the black <br/>Queen’s side.`
    },
    chessboard: {
      board: lesson10Assignment2({
        showIndicators: { allSides: true },
        position: 'r3kbnr/ppqnppp1/2p4p/7P/3P4/3Q1NN1/3B1PP1/R3K2R',
        finalPosition: '2kr1bnr/ppqnppp1/2p4p/7P/3P4/3Q1NN1/3B1PP1/R3K2R',
        startChance: ' b KQkq - 0 1',
        assignmentClass: 'custom-sparepiece',
        kingTarget: 'c8',
        rookTarget: 'd8',
        source: 'e8',
        target: 'c8',
        next: 7
      }),
      positionFen: 'r3kbnr/ppqnppp1/2p4p/7P/3P4/3Q1NN1/3B1PP1/R3K2R b KQkq - 0 1'
    }
  },
  {
    id: 6,
    previous: 2,
    next: 13,
    video: {
      src: 'img/videos/lesson_10/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 8,
    }
  },
  {
    id: 7,
    previous: 2,
    next: 13,
    video: {
      src: 'img/videos/lesson_10/3.1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 8,
    }
  },
  {
    id: 8,
    previous: 6,
    next: 9,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board <br/>to decide if you <br/>can castle, or why <br/>you can’t castle.`,
      className: 'no-animation'
    },
    options: {
      id: 0,
      answer: [
        'Yes, I can castle',
        'No, the King or Rook already moved',
        'No, squares between them aren’t empty',
        'No, the King would pass through or end in check'
      ],
      rightAnswer: 'a "Block"',
      magnusWrongAnswer: {
        data: 'Oops! The King and Rook can’t castle because there is a Knight in the way.',
        styleClass: 'lg',
        waitTime: 4000
      },
      highlightSquare: "square-g8",
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/4P3/P1N2N2/1PPP1PPP/R1BQKB1R',
        next: 9
      }),
      heading: 'Black Kingside Castle'
    }
  },
  {
    id: 9,
    previous: 8,
    next: 11,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board <br/>to decide if you <br/>can castle, or why <br/>you can’t castle.`,
      className: 'no-animation'
    },
    options: {
      id: 1,
      answer: [
        'Yes, I can castle',
        'No, the King or Rook already moved',
        'No, squares between them aren’t empty',
        'No, the King would pass through or end in check'
      ],
      next: 10,
      rightAnswer: 'a "Block"',
      magnusWrongAnswer: {
        data: 'It’s all good, the King and Rook can castle!',
        styleClass: 'lg',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R',
        next: 10
      }),
      heading: 'White Kingside Castle'
    }
  },
  {
    id: 10,
    previous: 8,
    next: 11,
    chessboard: {
      board: lesson10Assignment3({
        showIndicators: { allSides: true },
        position: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R',
        finalPosition: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1',
        next: 11
      }),
      heading: 'White Kingside Castle'
    }
  },
  {
    id: 11,
    previous: 9,
    next: 12,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board <br/>to decide if you <br/>can castle, or why <br/>you can’t castle.`,
      className: 'no-animation'
    },
    options: {
      id: 2,
      answer: [
        'Yes, I can castle',
        'No, the King or Rook already moved',
        'No, squares between them aren’t empty',
        'No, the King would pass through or end in check'
      ],
      rightAnswer: 'a "Block"',
      magnusWrongAnswer: {
        data: 'Oops! The King would pass through the Bishop’s attack on d1',
        styleClass: 'lg',
        waitTime: 4000
      },
      canvas: {
        from: 'square-g4',
        to: 'square-d1',
        offset: [2, 8, null, null],
        color: '#cc0000'
      },
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: 'r2qk2r/pp2ppbp/2np1np1/8/3NP1b1/2N1B3/PPPQ1PPP/R3KB1R',
        next: 12
      }),
      heading: 'White Queenside Castle'
    }
  },
  {
    id: 12,
    previous: 11,
    next: 13,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the board <br/>to decide if you <br/>can castle, or why <br/>you can’t castle.`,
      className: 'no-animation'
    },
    options: {
      id: 3,
      answer: [
        'Yes, I can castle',
        'No, the King or Rook already moved',
        'No, squares between them aren’t empty',
        'No, the King would pass through or end in check'
      ],
      rightAnswer: 'a "Block"',
      magnusWrongAnswer: {
        data: 'Oops! It looks like the King is not on his starting square.',
        styleClass: 'lg',
        waitTime: 4000
      },
      highlightSquare: "square-e8",
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: 'r2k1bnr/pppb1ppp/2n5/1B2p3/4P3/2N2N2/PPP2PPP/R1B1K2R',
        next: 13
      }),
      heading: 'Black Queenside Castle'
    }
  },
  {
    id: 13,
    previous: 6,
    next: 14,
    video: {
      src: 'img/videos/lesson_10/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 14,
    }
  },
  {
    id: 14,
    previous: 13,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: 'Castling is a special move using which two pieces?',
      answer: [
        'Pawn and Queen',
        'Knight and Queen',
        'Bishop and King',
        'Rook and King'
      ],
      rightAnswer: 'Rook and King',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 15,
    previous: 13,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: 'What is one of the rules of castling?',
      answer: [
        'The Rook has to be in the center of the board',
        'The Rook and King cannot have moved yet',
        'The King has to switch places with the Queen',
        'The Knight has to be on his starting square'
      ],
      rightAnswer: 'The Rook and King cannot have moved yet',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 16,
    previous: 13,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'What is the second rule of castling?',
      answer: [
        'The squares between the King and Rook must be empty',
        'The Bishop and Knight must be on their starting squares',
        'The pawn in front of the King must have moved',
        'The Queen must be between the King and Rook'
      ],
      rightAnswer: 'The squares between the King and Rook must be empty',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'lg'
    }
  },
  {
    id: 17,
    previous: 13,
    next: 18,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: 'What is the third rule of castling?',
      answer: [
        'The Rook has to be in the center of the board',
        'The Rook and King must have already moved',
        'The King cannot pass through or land in check',
        'The Queen has to be on her starting square'
      ],
      rightAnswer: 'The King cannot pass through or land in check',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 18,
    previous: 13,
    next: 19,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'What is one reason you castle?',
      answer: [
        'To checkmate the King',
        'To give the King more power',
        'To prevent your Rook being captured',
        'To move the King to a safer place'
      ],
      rightAnswer: 'To move the King to a safer place',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 19,
    previous: 13,
    next: 20,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'What is the second reason you castle?',
      answer: [
        'To promote your pawn',
        'To move the Rook to a more central place',
        'To prevent the Queen being captured',
        'To create a stalemate'
      ],
      rightAnswer: 'To move the Rook to a more central place',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'lg'
    }
  },
  {
    id: 20,
    previous: 13,
    next: 21,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'What does a “Queen side castle” mean?',
      answer: [
        'You castle on the Queen’s side of the board',
        'The Queen and Rook castle together',
        'The Queen and King castle together',
        'The Queen has to be on her starting square'
      ],
      rightAnswer: 'You castle on the Queen’s side of the board',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'lg'
    }
  },
  {
    id: 21,
    previous: 13,
    next: 22,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'Why is castling a unique move?',
      answer: [
        'Only White gets to castle',
        'Only Black gets to castle',
        "It's the only time Black and White move together",
        "It's the only time two pieces move at the same time"
      ],
      rightAnswer: 'It’s the only time two pieces move at the same time',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 22,
    previous: 13,
    next: 23,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'A King side castle happens on what part of the board?',
      answer: [
        'Files a-d',
        'Files e-h',
        'Ranks 1-4',
        'Ranks 5-8'
      ],
      rightAnswer: 'Files e-h',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md',
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
    }
  },
  {
    id: 23,
    previous: 13,
    next: 24,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'A Queen side castle happens on what part of the board?',
      answer: [
        'Files a-d',
        'Files e-h',
        'Ranks 1-4',
        'Ranks 5-8'
      ],
      rightAnswer: 'Files a-d',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md',
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
    }
  },
  {
    id: 24,
    previous: 13,
    next: 25,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      nextLesson: 'First Move 202',
      result: true,
      styleClass: 'xl',
      timeout: 7000
    }
  },
  {
    id: 25,
    previous: 13,
    next: null,
    video: {
      src: 'img/videos/lesson_10/5.mp4',
      startTime: 0,
      autoStartNext: true,
      next: null,
    }
  },
];

let assets = [
  '/img/background_9.png',
  '/img/background_10.png',
  '/img/box.png',
  '/img/chesspieces/assignment_10_1/bK.svg',
  '/img/chesspieces/assignment_10_1/bQ.svg',
  '/img/chesspieces/assignment_10_1/bR.svg',
  '/img/chesspieces/assignment_10_1/bB.svg',
  '/img/chesspieces/assignment_10_1/bN.svg',
  '/img/chesspieces/assignment_10_1/bP.svg'
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_10/index.js